export const BASE_API_URL = 'https://ver2.viamenus.com';